<!-- multi-select.component.html -->
<div
  class="multi-select-container"
  (click)="toggleDropdown()"
  [class.disabled]="disabled"
>
  <div
    class="selected-options"
    [class.invalid]="formControl.invalid && formControl.touched"
  >
    <span
      *ngFor="let option of selectedOptions"
      class="selected-chip"
      (click)="removeOption(option); $event.stopPropagation()"
    >
      {{ option.valueToDisplay }} ✕
    </span>

    <span *ngIf="selectedOptions.length === 0">
      {{ placeholder }}
    </span>
  </div>

  <div class="dropdown" *ngIf="isOpen">
    <div
      class="option"
      *ngFor="let option of options"
      [class.selected]="isSelected(option)"
      (click)="toggleSelection(option)"
    >
      <input type="checkbox" [checked]="isSelected(option)" />
      <label>{{ option.valueToDisplay }}</label>
    </div>
  </div>
</div>
